<template>
  <CModal
    title="ยืนยันการลบ"
    :show.sync="isShow"
    :closeOnBackdrop="false"
    centered
  >
    <CRow>
      <CCol sm="12" class="mt-3 mb-3">
        <div>ต้องการลบ <b>{{ name }}</b>?</div>
      </CCol>
    </CRow>
    <template slot="footer">
      <CButton
        color="dark"
        variant="outline"
        @click="cancle"
      >
        ยกเลิก
      </CButton>
      <CButton
        color="danger"
        @click="confirm"
      >
        ยืนยัน
      </CButton>
    </template>
    <!-- <template slot="body-wrapper">
      <span/>
    </template> -->
  </CModal>
</template>

<script>
export default {
  name: 'DeleteModal',
  props: {
    onConfirm: Function
  },
  data() {
    return {
      isShow: false,
      id: '',
      name: '',
    }
  },
  methods: {
    show(id, name) {
      this.isShow = true
      this.id = id
      this.name = name
    },
    cancle() {
      this.isShow = false
      this.id = ''
      this.name = ''
    },
    confirm() {
      this.onConfirm(this.id)

      this.isShow = false
      this.id = ''
      this.name = ''
    }
  }
}
</script>